export enum PaymentSelectionHook {
  Payment_Selection = 'payment-selection',
  Title = 'title',
  Divider = 'divider',
}
